export const getImageSrcFromBase64 = (base64: string) => {
  return `data:image/png;base64,${base64}`;
};
